import { ReactNode, useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { mediaBreakpoints } from '@/constants/grid'

interface IScreen {
  children: ReactNode
  size: string
  down?: boolean
}

const Screen = ({ children, size, down }: IScreen): any => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])

  const screenDown = useMediaQuery({
    maxWidth: mediaBreakpoints[size] - 0.02
  })
  const screen = useMediaQuery({
    minWidth: mediaBreakpoints[size]
  })

  return mounted && (down ? screenDown : screen) ? children : null
}

export default Screen
